import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {projectApi} from '../api';
import {ProjectModel} from '../model';

export type ProjectState = {
  getProject: UseQueryResult<ProjectModel, Error>;
};

export const useProject = (): ProjectState => {
  const getProject = useQuery<ProjectModel, Error>({
    queryKey: ['project'],
    queryFn: projectApi.getProject,
    staleTime: 60 * 1000,
  });

  return {
    getProject,
  };
};
